module.exports = __webpack_public_path__ + "img/forte8.aeedd859.jpeg";